var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-wrapper d-flex flex-column align-center mt-2"},[(_vm.pageLoader)?_c('PageLoader'):_vm._l((_vm.areas),function(area,i){return _c('AreaPreview',{key:area.name + i,class:i == _vm.areas.length - 1 ? 'mb-12' : '',attrs:{"area":area}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }